
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWarningGoogle as ObiWarningGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-warning-google.js';
 
 
 

 
 export const ObiWarningGoogle = createComponent({
   react: React,
   tagName: 'obi-warning-google',
   elementClass: ObiWarningGoogleElement,
   events: {
     
   }
  });
 
 